import { FC } from 'react'

import { Size } from '@syconium/little-miss-figgy'

import { useTranslation } from '../../../../../../app/_providers/TranslationProvider.client'
import { trackEvent } from '../../../../../../lib/analytics'
import { prettySizeName } from '../../../../../../lib/utils/tech-debt'
import { SoldOutMessage } from '../styles'

interface Props {
  isProductWaitlistable: boolean
  selectedSize: Size | undefined
  category: string
  hideTitle?: boolean
}

export const SizeSelection: FC<Props> = ({
  selectedSize,
  category,
  isProductWaitlistable,
  hideTitle,
}) => {
  const {
    detailsSection: { soldOutSectionTitleMessage },
  } = useTranslation()

  if (!selectedSize || hideTitle) return null
  return (
    <div
      {...trackEvent({
        category,
        action: 'snapshot',
        label: 'size',
        value: selectedSize.shorthand,
      })}
    >
      {prettySizeName(selectedSize.shorthand)}
      {selectedSize.soldOut && !isProductWaitlistable && (
        <SoldOutMessage>&nbsp;{soldOutSectionTitleMessage}</SoldOutMessage>
      )}
    </div>
  )
}
